/**
 * 设备 / 宿主环境探测工具
 */

/**
 * 是否在微信内置浏览器中打开（UA 含 MicroMessenger）。
 * 微信 WebView 对 <input type="file"> 的 accept 支持有限：
 * - `image/*` → 弹「拍摄 / 从手机相册选择」原生面板，可用；
 * - 含 `.pdf` 等扩展名的 accept → 仍被当作图片选择，无法调起系统文件管理器，
 *   PDF 等文档只能引导用户用系统浏览器打开页面后再上传。
 */
export function isWeChatBrowser(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /MicroMessenger/i.test(navigator.userAgent || '');
}
